import React from 'react';

function Categories({ value, onChangeCategory, name }) {
  const categories = ['Все продукты', 'Хлеб и макаронные изделия', 'Молочное и яйца', 'Мясо и фарш', 'Овощи и зелень', 'Фрукты и ягоды','Напитки'];
  return (
    <div className="categories">
      <ul>
        {categories.map((categoryName, index) => (
          <li
            key={index}
            onClick={() => onChangeCategory(index,categoryName)}
            className={value === index ? 'active' : ' '}>
            {name=categoryName}
          </li>
        ))}
      </ul>
    </div>
  );
}
export default Categories;
